import script from "./DefPriceEN.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefPriceEN.vue?vue&type=script&lang=ts&setup=true"

import "./DefPriceEN.vue?vue&type=style&index=0&id=d81d389a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d81d389a"]])

export default __exports__